var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFoodiesLogoClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.95871 0.743628H16.1189L15.7435 3.7917H8.89634L8.4546 7.54657H14.374L13.9765 10.6167H8.05702L7.28396 17H3.97084L5.95871 0.743628Z",
    fill: "#DBDBDB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.42356 0.743628H13.5838L13.2083 3.7917H6.36119L5.91944 7.54657H11.8389L11.4413 10.6167H5.52186L4.7488 17H1.43568L3.42356 0.743628Z",
    fill: "#EE2A27"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodiesLogoClosed);
export default __webpack_public_path__ + "static/media/foodies-logo-closed.b98e3a22269f46988ea5bb27fed24be4.svg";
export { ForwardRef as ReactComponent };